"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "DataTableService", {
    enumerable: true,
    get: function() {
        return DataTableService;
    }
});
const _common = require("@nestjs/common");
const _nocodbsdk = require("nocodb-sdk");
const _helpers = require("src/helpers");
const _dataHelpers = require("~/helpers/dataHelpers");
const _models = require("~/models");
const _utils = require("~/utils");
const _datasservice = require("~/services/datas.service");
const _catchError = require("~/helpers/catchError");
const _getAst = /*#__PURE__*/ _interop_require_default(require("~/helpers/getAst"));
const _PagedResponse = require("~/helpers/PagedResponse");
const _NcConnectionMgrv2 = /*#__PURE__*/ _interop_require_default(require("~/utils/common/NcConnectionMgrv2"));
const _dbHelpers = require("~/helpers/dbHelpers");
const _profiler = require("~/helpers/profiler");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
    }
    return target;
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
let DataTableService = class DataTableService {
    async dataList(context, param) {
        const { modelId, viewId, baseId, user } = param, rest = _object_without_properties_loose(param, [
            "modelId",
            "viewId",
            "baseId",
            "user"
        ]);
        const { model, view } = await this.getModelAndView(context, {
            modelId,
            viewId,
            baseId,
            user
        });
        return await this.datasService.dataList(context, _extends({}, rest, {
            model,
            view,
            apiVersion: param.apiVersion,
            includeSortAndFilterColumns: param == null ? void 0 : param.includeSortAndFilterColumns
        }));
    }
    async dataRead(context, param) {
        const { model, view } = await this.getModelAndView(context, param);
        const source = await _models.Source.get(context, model.source_id);
        const baseModel = await _models.Model.getBaseModelSQL(context, {
            id: model.id,
            viewId: view == null ? void 0 : view.id,
            dbDriver: await _NcConnectionMgrv2.default.get(source),
            source
        });
        const row = await baseModel.readByPk(param.rowId, false, param.query, {
            throwErrorIfInvalidParams: true,
            apiVersion: param.apiVersion
        });
        if (!row) {
            _catchError.NcError.get(context).recordNotFound(param.rowId);
        }
        return row;
    }
    async dataAggregate(context, param) {
        const { model, view } = await this.getModelAndView(context, param);
        const source = await _models.Source.get(context, model.source_id);
        const baseModel = await _models.Model.getBaseModelSQL(context, {
            id: model.id,
            viewId: view == null ? void 0 : view.id,
            dbDriver: await _NcConnectionMgrv2.default.get(source),
            source
        });
        if (view && view.type !== _nocodbsdk.ViewTypes.GRID) {
            _catchError.NcError.get(context).badRequest('Aggregation is only supported on grid views');
        }
        const listArgs = _extends({}, param.query);
        try {
            listArgs.filterArr = JSON.parse(listArgs.filterArrJson);
        } catch (e) {}
        try {
            listArgs.aggregation = JSON.parse(listArgs.aggregation);
        } catch (e) {}
        const data = await baseModel.aggregate(listArgs, view);
        return data;
    }
    async dataInsert(context, param) {
        var _ref;
        var _param_cookie_query, _param_cookie, _param_internalFlags, _param_internalFlags1;
        (0, _dataHelpers.validateV1V2DataPayloadLimit)(context, param);
        const { model, view } = await this.getModelAndView(context, param);
        const source = await _models.Source.get(context, model.source_id);
        const baseModel = await _models.Model.getBaseModelSQL(context, {
            id: model.id,
            viewId: view == null ? void 0 : view.id,
            dbDriver: await _NcConnectionMgrv2.default.get(source)
        });
        // if array then do bulk insert
        const result = await baseModel.bulkInsert(Array.isArray(param.body) ? param.body : [
            param.body
        ], {
            cookie: param.cookie,
            insertOneByOneAsFallback: true,
            isSingleRecordInsertion: !Array.isArray(param.body),
            typecast: ((_ref = (_param_cookie = param.cookie) == null ? void 0 : (_param_cookie_query = _param_cookie.query) == null ? void 0 : _param_cookie_query.typecast) != null ? _ref : '') === 'true',
            undo: param.undo,
            apiVersion: param.apiVersion,
            allowSystemColumn: (_param_internalFlags = param.internalFlags) == null ? void 0 : _param_internalFlags.allowSystemColumn,
            skip_hooks: (_param_internalFlags1 = param.internalFlags) == null ? void 0 : _param_internalFlags1.skipHooks
        });
        return Array.isArray(param.body) ? result : result[0];
    }
    async dataMove(context, param) {
        const { model, view } = await this.getModelAndView(context, param);
        const source = await _models.Source.get(context, model.source_id);
        const baseModel = await _models.Model.getBaseModelSQL(context, {
            id: model.id,
            viewId: view == null ? void 0 : view.id,
            dbDriver: await _NcConnectionMgrv2.default.get(source)
        });
        await baseModel.moveRecord({
            cookie: param.cookie,
            rowId: param.rowId,
            beforeRowId: param.beforeRowId
        });
        return true;
    }
    async dataUpdate(context, param) {
        var _ref;
        var _param_cookie_query, _param_cookie, _param_internalFlags, _param_internalFlags1;
        (0, _dataHelpers.validateV1V2DataPayloadLimit)(context, param);
        const profiler = _profiler.Profiler.start(`data-table/dataUpdate`);
        const { model, view } = await this.getModelAndView(context, param);
        profiler.log('getModelAndView done');
        await this.checkForDuplicateRow(context, {
            rows: param.body,
            model
        });
        profiler.log('checkForDuplicateRow done');
        const source = await _models.Source.get(context, model.source_id);
        const baseModel = await _models.Model.getBaseModelSQL(context, {
            id: model.id,
            viewId: view == null ? void 0 : view.id,
            dbDriver: await _NcConnectionMgrv2.default.get(source)
        });
        await baseModel.bulkUpdate(Array.isArray(param.body) ? param.body : [
            param.body
        ], {
            cookie: param.cookie,
            throwExceptionIfNotExist: true,
            typecast: ((_ref = (_param_cookie = param.cookie) == null ? void 0 : (_param_cookie_query = _param_cookie.query) == null ? void 0 : _param_cookie_query.typecast) != null ? _ref : '') === 'true',
            isSingleRecordUpdation: !Array.isArray(param.body),
            apiVersion: param.apiVersion,
            allowSystemColumn: (_param_internalFlags = param.internalFlags) == null ? void 0 : _param_internalFlags.allowSystemColumn,
            skip_hooks: (_param_internalFlags1 = param.internalFlags) == null ? void 0 : _param_internalFlags1.skipHooks
        });
        profiler.log('extractIdObj');
        const result = this.extractIdObj(context, {
            body: param.body,
            model
        });
        profiler.end();
        return result;
    }
    async dataDelete(context, param) {
        (0, _dataHelpers.validateV1V2DataPayloadLimit)(context, param);
        const { model, view } = await this.getModelAndView(context, param);
        await this.checkForDuplicateRow(context, {
            rows: param.body,
            model
        });
        const source = await _models.Source.get(context, model.source_id);
        const baseModel = await _models.Model.getBaseModelSQL(context, {
            id: model.id,
            viewId: view == null ? void 0 : view.id,
            dbDriver: await _NcConnectionMgrv2.default.get(source)
        });
        await baseModel.bulkDelete(Array.isArray(param.body) ? param.body : [
            param.body
        ], {
            cookie: param.cookie,
            throwExceptionIfNotExist: true,
            isSingleRecordDeletion: !Array.isArray(param.body)
        });
        return this.extractIdObj(context, {
            body: param.body,
            model
        });
    }
    async dataCount(context, param) {
        const { model, view } = await this.getModelAndView(context, param);
        const source = await _models.Source.get(context, model.source_id);
        const baseModel = await _models.Model.getBaseModelSQL(context, {
            id: model.id,
            viewId: view == null ? void 0 : view.id,
            dbDriver: await _NcConnectionMgrv2.default.get(source)
        });
        const countArgs = _extends({}, param.query);
        try {
            countArgs.filterArr = JSON.parse(countArgs.filterArrJson);
        } catch (e) {}
        const count = await baseModel.count(countArgs, false, true);
        return {
            count
        };
    }
    async getModelAndView(context, param) {
        const model = await _models.Model.get(context, param.modelId);
        if (!model) {
            _catchError.NcError.get(context).tableNotFound(param.modelId);
        }
        if (param.baseId && model.base_id !== param.baseId) {
            _catchError.NcError.get(context).tableNotFound(param.modelId);
        }
        // Table visibility permission is checked in extract-ids middleware
        // No need to check here to avoid circular dependency
        let view;
        if (param.viewId) {
            view = await _models.View.get(context, param.viewId);
            if (!view || view.fk_model_id && view.fk_model_id !== param.modelId) {
                _catchError.NcError.get(context).viewNotFound(param.viewId);
            }
        }
        return {
            model,
            view
        };
    }
    async extractIdObj(context, { model, body }) {
        const pkColumns = await model.getColumns(context).then((cols)=>cols.filter((col)=>col.pk));
        const result = (Array.isArray(body) ? body : [
            body
        ]).map((row)=>{
            return pkColumns.reduce((acc, col)=>{
                var _ref, _row_col_title;
                acc[col.title] = (_ref = (_row_col_title = row[col.title]) != null ? _row_col_title : row[col.column_name]) != null ? _ref : row[col.id];
                return acc;
            }, {});
        });
        return Array.isArray(body) ? result : result[0];
    }
    async checkForDuplicateRow(context, { rows, model }) {
        if (!rows || !Array.isArray(rows) || rows.length === 1) {
            return;
        }
        await model.getColumns(context);
        const keys = new Set();
        for (const row of rows){
            var _ref, _row_model_primaryKey_title;
            let pk;
            // TODO: refactor to extractPkValues of baseModelSqlV2
            // if only one primary key then extract the value
            if (model.primaryKeys.length === 1) pk = (_ref = (_row_model_primaryKey_title = row[model.primaryKey.title]) != null ? _row_model_primaryKey_title : row[model.primaryKey.column_name]) != null ? _ref : row[model.primaryKey.id];
            else pk = model.primaryKeys.map((pk)=>{
                var _ref, _row_pk_title;
                var _toString, _toString1, _this;
                return (_this = (_ref = (_row_pk_title = row[pk.title]) != null ? _row_pk_title : row[pk.column_name]) != null ? _ref : row[pk.id]) == null ? void 0 : (_toString1 = _this.toString) == null ? void 0 : (_toString = _toString1.call(_this)) == null ? void 0 : _toString.replaceAll('_', '\\_');
            }).join('___');
            // if duplicate then throw error
            if (keys.has(pk)) {
                _catchError.NcError.get(context).unprocessableEntity('Duplicate record with id ' + pk);
            }
            if (pk === undefined || pk === null) {
                _catchError.NcError.get(context).unprocessableEntity('Primary key is required');
            }
            keys.add(pk);
        }
    }
    async nestedDataList(context, param) {
        var _param_query, _param_query1, _column_meta;
        const { model, view } = await this.getModelAndView(context, param);
        const source = await _models.Source.get(context, model.source_id);
        const baseModel = await _models.Model.getBaseModelSQL(context, {
            id: model.id,
            viewId: view == null ? void 0 : view.id,
            dbDriver: await _NcConnectionMgrv2.default.get(source)
        });
        if (!await baseModel.exist(param.rowId)) {
            _catchError.NcError.get(context).recordNotFound(`${param.rowId}`);
        }
        const column = await this.getColumn(context, param);
        const colOptions = await column.getColOptions(context);
        const relatedModel = await colOptions.getRelatedTable(context);
        const { ast, dependencyFields } = await (0, _getAst.default)(context, {
            model: relatedModel,
            query: param.query,
            extractOnlyPrimaries: !(((_param_query = param.query) == null ? void 0 : _param_query.f) || ((_param_query1 = param.query) == null ? void 0 : _param_query1.fields))
        });
        const listArgs = dependencyFields;
        try {
            listArgs.filterArr = JSON.parse(listArgs.filterArrJson);
        } catch (e) {}
        try {
            listArgs.sortArr = JSON.parse(listArgs.sortArrJson);
        } catch (e) {}
        if ((0, _nocodbsdk.ncIsNumber)(Number(param.query.limit)) && Number(param.query.limit) > 0) {
            listArgs.nestedLimit = param.query.limit;
        }
        let data;
        let count;
        if (colOptions.type === _nocodbsdk.RelationTypes.MANY_TO_MANY) {
            data = await baseModel.mmList({
                colId: column.id,
                parentId: param.rowId,
                apiVersion: param.apiVersion
            }, listArgs);
            count = await baseModel.mmListCount({
                colId: column.id,
                parentId: param.rowId
            }, param.query);
        } else if (colOptions.type === _nocodbsdk.RelationTypes.HAS_MANY) {
            data = await baseModel.hmList({
                colId: column.id,
                id: param.rowId,
                apiVersion: param.apiVersion
            }, listArgs);
            count = await baseModel.hmListCount({
                colId: column.id,
                id: param.rowId
            }, param.query);
        } else if (colOptions.type !== _nocodbsdk.RelationTypes.BELONGS_TO && !((_column_meta = column.meta) == null ? void 0 : _column_meta.bt)) {
            data = await baseModel.ooRead({
                colId: column.id,
                id: param.rowId,
                apiVersion: param.apiVersion
            }, param.query);
        } else {
            data = await baseModel.btRead({
                colId: column.id,
                id: param.rowId,
                apiVersion: param.apiVersion
            }, param.query);
        }
        data = await (0, _utils.nocoExecute)(ast, data, {}, listArgs);
        if (colOptions.type === _nocodbsdk.RelationTypes.BELONGS_TO) return data;
        return new _PagedResponse.PagedResponseImpl(data, _extends({
            count
        }, param.query));
    }
    async getColumn(context, param) {
        const column = await _models.Column.get(context, {
            colId: param.columnId
        });
        if (!column) _catchError.NcError.get(context).fieldNotFound(param.columnId);
        if (column.fk_model_id !== param.modelId) _catchError.NcError.get(context).badRequest('Column not belong to model');
        if (!(0, _nocodbsdk.isLinksOrLTAR)(column)) _catchError.NcError.get(context).badRequest('Column is not LTAR');
        return column;
    }
    async nestedLink(context, param) {
        this.validateIds(context, param.refRowIds);
        const { model, view } = await this.getModelAndView(context, param);
        const source = await _models.Source.get(context, model.source_id);
        const baseModel = await _models.Model.getBaseModelSQL(context, {
            id: model.id,
            viewId: view == null ? void 0 : view.id,
            dbDriver: await _NcConnectionMgrv2.default.get(source)
        });
        const column = await this.getColumn(context, param);
        await baseModel.addLinks({
            colId: column.id,
            childIds: Array.isArray(param.refRowIds) ? param.refRowIds : [
                param.refRowIds
            ],
            rowId: param.rowId,
            cookie: param.cookie
        });
        return true;
    }
    async nestedUnlink(context, param) {
        this.validateIds(context, param.refRowIds);
        const { model, view } = await this.getModelAndView(context, param);
        if (!model) _catchError.NcError.get(context).tableNotFound(param.modelId);
        const source = await _models.Source.get(context, model.source_id);
        const baseModel = await _models.Model.getBaseModelSQL(context, {
            id: model.id,
            viewId: view == null ? void 0 : view.id,
            dbDriver: await _NcConnectionMgrv2.default.get(source)
        });
        const column = await this.getColumn(context, param);
        await baseModel.removeLinks({
            colId: column.id,
            childIds: Array.isArray(param.refRowIds) ? param.refRowIds : [
                param.refRowIds
            ],
            rowId: param.rowId,
            cookie: param.cookie
        });
        return true;
    }
    // todo: naming & optimizing
    async nestedListCopyPasteOrDeleteAll(context, param) {
        var _param_query, _param_query1;
        (0, _helpers.validatePayload)('swagger.json#/components/schemas/nestedListCopyPasteOrDeleteAllReq', param.data);
        const operationMap = param.data.reduce((map, p)=>{
            map[p.operation] = p;
            return map;
        }, {});
        if (!operationMap.deleteAll && operationMap.copy.fk_related_model_id !== operationMap.paste.fk_related_model_id) {
            _catchError.NcError.get(context).badRequest('The operation is not supported on different fk_related_model_id');
        }
        const { model, view } = await this.getModelAndView(context, param);
        const source = await _models.Source.get(context, model.source_id);
        const baseModel = await _models.Model.getBaseModelSQL(context, {
            id: model.id,
            viewId: view == null ? void 0 : view.id,
            dbDriver: await _NcConnectionMgrv2.default.get(source)
        });
        if (operationMap.deleteAll && !await baseModel.exist(operationMap.deleteAll.rowId)) {
            _catchError.NcError.get(context).recordNotFound(operationMap.deleteAll.rowId);
        } else if (operationMap.copy && operationMap.paste) {
            const [existsCopyRow, existsPasteRow] = await Promise.all([
                baseModel.exist(operationMap.copy.rowId),
                baseModel.exist(operationMap.paste.rowId)
            ]);
            if (!existsCopyRow && !existsPasteRow) {
                _catchError.NcError.get(context).recordNotFound(`'${operationMap.copy.rowId}' and '${operationMap.paste.rowId}'`);
            } else if (!existsCopyRow) {
                _catchError.NcError.get(context).recordNotFound(operationMap.copy.rowId);
            } else if (!existsPasteRow) {
                _catchError.NcError.get(context).recordNotFound(operationMap.paste.rowId);
            }
        }
        const column = await this.getColumn(context, param);
        const colOptions = await column.getColOptions(context);
        const { refContext } = await colOptions.getParentChildContext(context);
        const relatedModel = await colOptions.getRelatedTable(refContext);
        await relatedModel.getColumns(refContext);
        if (colOptions.type !== _nocodbsdk.RelationTypes.MANY_TO_MANY) return;
        const { dependencyFields } = await (0, _getAst.default)(refContext, {
            model: relatedModel,
            query: param.query,
            extractOnlyPrimaries: !(((_param_query = param.query) == null ? void 0 : _param_query.f) || ((_param_query1 = param.query) == null ? void 0 : _param_query1.fields))
        });
        const listArgs = dependencyFields;
        try {
            listArgs.filterArr = JSON.parse(listArgs.filterArrJson);
        } catch (e) {}
        try {
            listArgs.sortArr = JSON.parse(listArgs.sortArrJson);
        } catch (e) {}
        if (operationMap.deleteAll) {
            let deleteCellNestedList = await baseModel.mmList({
                colId: column.id,
                parentId: operationMap.deleteAll.rowId
            }, listArgs, true);
            if (deleteCellNestedList && Array.isArray(deleteCellNestedList)) {
                await baseModel.removeLinks({
                    colId: column.id,
                    childIds: deleteCellNestedList.map((nestedList)=>(0, _dbHelpers.dataWrapper)(nestedList).extractPksValue(relatedModel)),
                    rowId: operationMap.deleteAll.rowId,
                    cookie: param.cookie
                });
                // extract only pk row data
                deleteCellNestedList = deleteCellNestedList.map((nestedList)=>{
                    return relatedModel.primaryKeys.reduce((acc, col)=>{
                        acc[col.title || col.column_name] = nestedList[col.title || col.column_name];
                        return acc;
                    }, {});
                });
            } else {
                deleteCellNestedList = [];
            }
            return {
                link: [],
                unlink: deleteCellNestedList
            };
        } else if (operationMap.copy && operationMap.paste) {
            const [copiedCellNestedList, pasteCellNestedList] = await Promise.all([
                baseModel.mmList({
                    colId: operationMap.copy.columnId,
                    parentId: operationMap.copy.rowId
                }, listArgs, true),
                baseModel.mmList({
                    colId: column.id,
                    parentId: operationMap.paste.rowId
                }, listArgs, true)
            ]);
            const filteredRowsToLink = this.filterAndMapRows(copiedCellNestedList, pasteCellNestedList, relatedModel);
            const filteredRowsToUnlink = this.filterAndMapRows(pasteCellNestedList, copiedCellNestedList, relatedModel);
            await Promise.all([
                filteredRowsToLink.length && baseModel.addLinks({
                    colId: column.id,
                    childIds: filteredRowsToLink,
                    rowId: operationMap.paste.rowId,
                    cookie: param.cookie
                }),
                filteredRowsToUnlink.length && baseModel.removeLinks({
                    colId: column.id,
                    childIds: filteredRowsToUnlink,
                    rowId: operationMap.paste.rowId,
                    cookie: param.cookie
                })
            ]);
            return {
                link: filteredRowsToLink,
                unlink: filteredRowsToUnlink
            };
        }
    }
    validateIds(context, rowIds) {
        if (Array.isArray(rowIds)) {
            const map = new Map();
            const set = new Set();
            for (const rowId of rowIds){
                if (rowId === undefined || rowId === null) _catchError.NcError.get(context).recordNotFound(rowId);
                if (map.has(rowId)) {
                    set.add(rowId);
                } else {
                    map.set(rowId, true);
                }
            }
            if (set.size > 0) _catchError.NcError.get(context).duplicateRecord([
                ...set
            ]);
        } else if (rowIds === undefined || rowIds === null) {
            _catchError.NcError.get(context).recordNotFound(rowIds);
        }
    }
    filterAndMapRows(sourceList, targetList, relatedModel) {
        return sourceList.filter((sourceRow)=>!targetList.some((targetRow)=>relatedModel.primaryKeys.every((key)=>sourceRow[key.title || key.column_name] === targetRow[key.title || key.column_name]))).map((item)=>(0, _dbHelpers.dataWrapper)(item).extractPksValue(relatedModel, true));
    }
    async bulkDataList(context, param) {
        const { model, view } = await this.getModelAndView(context, param);
        let bulkFilterList = param.body;
        try {
            bulkFilterList = JSON.parse(bulkFilterList);
        } catch (e) {}
        if (!(bulkFilterList == null ? void 0 : bulkFilterList.length)) {
            _catchError.NcError.get(context).badRequest('Invalid bulkFilterList');
        }
        const results = await (0, _utils.processConcurrently)(bulkFilterList, async (dF)=>{
            const data = await this.datasService.dataList(context, {
                query: _extends({}, dF),
                model,
                view,
                includeRowColorColumns: dF.include_row_color === 'true',
                includeButtonFilterColumns: dF.include_button_filter_columns === 'true'
            });
            return {
                alias: dF.alias,
                data
            };
        }, 5);
        return results.reduce((acc, { alias, data })=>{
            acc[alias] = data;
            return acc;
        }, {});
    }
    async bulkGroupBy(context, param) {
        const { model, view } = await this.getModelAndView(context, param);
        const source = await _models.Source.get(context, model.source_id);
        const baseModel = await _models.Model.getBaseModelSQL(context, {
            id: model.id,
            viewId: view == null ? void 0 : view.id,
            dbDriver: await _NcConnectionMgrv2.default.get(source)
        });
        let bulkFilterList = param.body;
        const listArgs = _extends({}, param.query);
        try {
            bulkFilterList = JSON.parse(bulkFilterList);
        } catch (e) {}
        try {
            listArgs.filterArr = JSON.parse(listArgs.filterArrJSON);
        } catch (e) {}
        if (!(bulkFilterList == null ? void 0 : bulkFilterList.length)) {
            _catchError.NcError.get(context).badRequest('Invalid bulkFilterList');
        }
        const [data, count] = await Promise.all([
            baseModel.bulkGroupBy(listArgs, bulkFilterList, view),
            baseModel.bulkGroupByCount(listArgs, bulkFilterList, view)
        ]);
        bulkFilterList.forEach((dF)=>{
            // sqlite3 returns data as string. Hence needs to be converted to json object
            let parsedData = data[dF.alias];
            if (typeof parsedData === 'string') {
                parsedData = JSON.parse(parsedData);
            }
            let parsedCount = count[dF.alias];
            if (typeof parsedCount === 'string') {
                parsedCount = JSON.parse(parsedCount);
            }
            data[dF.alias] = new _PagedResponse.PagedResponseImpl(parsedData, _extends({}, dF, {
                count: parsedCount == null ? void 0 : parsedCount.count
            }));
        });
        return data;
    }
    async bulkAggregate(context, param) {
        const { model, view } = await this.getModelAndView(context, param);
        const source = await _models.Source.get(context, model.source_id);
        const baseModel = await _models.Model.getBaseModelSQL(context, {
            id: model.id,
            viewId: view == null ? void 0 : view.id,
            dbDriver: await _NcConnectionMgrv2.default.get(source)
        });
        if (view && view.type !== _nocodbsdk.ViewTypes.GRID) {
            _catchError.NcError.badRequest('Aggregation is only supported on grid views');
        }
        const listArgs = _extends({}, param.query);
        let bulkFilterList = param.body;
        try {
            listArgs.filterArr = JSON.parse(listArgs.filterArrJson);
        } catch (e) {}
        try {
            listArgs.aggregation = JSON.parse(listArgs.aggregation);
        } catch (e) {}
        try {
            bulkFilterList = JSON.parse(bulkFilterList);
        } catch (e) {}
        return await baseModel.bulkAggregate(listArgs, bulkFilterList, view);
    }
    async getLinkedDataList(context, params) {
        const { req, linkColumnId } = params;
        const relationColumn = await _models.Column.get(context, {
            colId: linkColumnId
        });
        if (!relationColumn || !(0, _nocodbsdk.isLinksOrLTAR)(relationColumn)) {
            _catchError.NcError.get(context).fieldNotFound(linkColumnId);
        }
        const { refContext } = relationColumn.colOptions.getRelContext(context);
        return this.dataList(refContext, {
            query: _extends({}, req.query, {
                columnId: undefined,
                linkColumnId,
                linkBaseId: context.base_id
            }),
            modelId: relationColumn.colOptions.fk_related_model_id,
            viewId: relationColumn.colOptions.fk_target_view_id,
            includeSortAndFilterColumns: req.query.includeSortAndFilterColumns === 'true',
            user: req.user
        });
    }
    constructor(datasService){
        this.datasService = datasService;
        this.logger = new _common.Logger(DataTableService.name);
    }
};
DataTableService = _ts_decorate([
    (0, _common.Injectable)(),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _datasservice.DatasService === "undefined" ? Object : _datasservice.DatasService
    ])
], DataTableService);
